import Reveal, { Eyebrow } from "../components/Reveal";
import CtaBand from "../components/CtaBand";
import { SERVICE_ICONS } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export default function Services() {
  const { t } = useLang();
  const items = t.services.items;

  return (
    <div data-testid="services-page">
      {/* Page header */}
      <section className="navy-texture text-white" data-testid="services-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <Reveal>
            <Eyebrow dark>{t.services.eyebrow}</Eyebrow>
            <h1 className="mt-6 font-serif-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] max-w-3xl text-balance">
              {t.services.pageTitle}
            </h1>
            <p className="mt-6 text-lg text-slate-200 max-w-2xl leading-relaxed">
              {t.services.subtitle}
            </p>
          </Reveal>
        </div>
      </section>

      {/* Grid */}
      <section className="bg-white" data-testid="services-grid">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <div className="grid gap-6 sm:grid-cols-2">
            {items.map((s, i) => {
              const Icon = SERVICE_ICONS[i];
              const id = String(i + 1).padStart(2, "0");
              return (
                <Reveal key={i} delay={i % 2}>
                  <div
                    data-testid={`service-card-${id}`}
                    className="group relative h-full bg-white border border-slate-200 rounded-sm p-8 md:p-10 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 border-b-4 border-b-transparent hover:border-b-[#C9A15A]"
                  >
                    <span className="absolute top-6 right-8 font-serif-display text-5xl font-bold text-slate-100 select-none">
                      {id}
                    </span>
                    <div className="h-14 w-14 rounded-full bg-[#C9A15A]/12 flex items-center justify-center">
                      <Icon className="h-7 w-7 text-[#C9A15A]" />
                    </div>
                    <h3 className="mt-6 font-serif-display text-xl font-bold text-[#1B3A5B] leading-snug max-w-xs">
                      {s.title}
                    </h3>
                    <p className="mt-4 text-slate-600 leading-relaxed">
                      {s.description}
                    </p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
